import { useStoreDollHouseMap } from "../../store";
import {
  ARIA,
  VDARA,
  BELLAGIO,
  PARK_MGM,
  THE_COSMOPOLITAN,
  NOMAD,
  DISTRICT_HIGHLIGHTS,
  TMOBILE,
} from "../../scripts/core/constants";
import { useEffect, useState } from "react";
import { shallow } from "zustand/shallow";
// import nomad_logo from "../../assets/images/nomad_logo.png";
// import tmobilearena from "../../assets/images/tmobilearena.png";
// import bagio_logo from "../../assets/images/bagio_logo.png";
// import vdara_logo from "../../assets/images/vdara_logo.png";
// import aria_logo from "../../assets/images/aria_logo.png";
// import cosmo from "../../assets/images/cosmo_logo.png";

import {
  ARIA_INFORMATION_LOGO,
  VDARA_INFORMATION_LOGO,
  BELLAGIO_INFORMATION_LOGO,
  PARK_MGM_INFORMATION_LOGO,
  COSMO_INFORMATION_LOGO,
  TMOBILE_INFORMATION_LOGO,
  NOMAD_INFORMATION_LOGO,
} from "../../layouts/ViewerScene";

import { __showDollHouseModal } from "../HotspotInfoModal";

export default function RoutePathBuildingHighlight() {
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      sourcePoidSelected: state.sourcePoidSelected,
      destinationPoidSelected: state.destinationPoidSelected,
      isRouteSubmitted: state.isRouteSubmitted,
      sourceAreaSelected: state.sourceAreaSelected,
      destinationAreaSelected: state.destinationAreaSelected,
    }),
    shallow
  );

  const [showAria, setAria] = useState(false);
  const [showTmobile, setTmobile] = useState(false);
  const [showVdara, setVdara] = useState(false);
  const [showBellagio, setBellagio] = useState(false);
  const [showParkmgm, setParkmgm] = useState(false);
  const [showNomad, setNomad] = useState(false);
  const [showCosmo, setCosmo] = useState(false);

  const hideallareas = () => {
    setAria(false);
    setTmobile(false);
    setVdara(false);
    setBellagio(false);
    setParkmgm(false);
    setNomad(false);
    setCosmo(false);
  };

  useEffect(() => {
    if (dollhouseStore.sourceAreaSelected === "") {
      hideallareas();
    }
  }, [dollhouseStore.sourceAreaSelected]);

  useEffect(() => {
    if (dollhouseStore.destinationAreaSelected === "") {
      hideallareas();
    }
  }, [dollhouseStore.destinationAreaSelected]);

  useEffect(() => {
    if (dollhouseStore.isRouteSubmitted) {
      hideallareas();

      // console.log(dollhouseStore.sourceAreaSelected);

      // console.log(dollhouseStore.destinationAreaSelected);

      if (dollhouseStore.sourceAreaSelected === ARIA) {
        setAria(true);
      }

      if (dollhouseStore.sourceAreaSelected === TMOBILE) {
        setTmobile(true);
      }

      if (dollhouseStore.sourceAreaSelected === VDARA) {
        setVdara(true);
      }

      if (dollhouseStore.sourceAreaSelected === BELLAGIO) {
        setBellagio(true);
      }

      if (dollhouseStore.sourceAreaSelected === THE_COSMOPOLITAN) {
        setCosmo(true);
      }

      if (dollhouseStore.sourceAreaSelected === PARK_MGM) {
        setParkmgm(true);
      }

      if (dollhouseStore.sourceAreaSelected === NOMAD) {
        setNomad(true);
      }

      if (dollhouseStore.sourceAreaSelected === "DOLBY LIVE THEATRE") {
        //setParkmgm(true)
      }

      if (dollhouseStore.destinationAreaSelected === ARIA) {
        setAria(true);
      }

      if (dollhouseStore.destinationAreaSelected === TMOBILE) {
        setTmobile(true);
      }

      if (dollhouseStore.destinationAreaSelected === VDARA) {
        setVdara(true);
      }

      if (dollhouseStore.destinationAreaSelected === BELLAGIO) {
        setBellagio(true);
      }

      if (dollhouseStore.destinationAreaSelected === THE_COSMOPOLITAN) {
        setCosmo(true);
      }

      if (dollhouseStore.destinationAreaSelected === PARK_MGM) {
        setParkmgm(true);
      }

      if (dollhouseStore.destinationAreaSelected === NOMAD) {
        setNomad(true);
      }

      if (dollhouseStore.destinationAreaSelected === "DOLBY LIVE THEATRE") {
        //setParkmgm(true)
      }
    }
  }, [dollhouseStore.isRouteSubmitted]);

  return (
    <>
      {showAria && <AriaHighlight />}
      {showTmobile && <TMobileHighlight />}
      {showVdara && <VdaraHighlight />}
      {showBellagio && <BellagioHighlight />}
      {showParkmgm && <ParkMgmHighlight />}
      {showNomad && <NomadHighlight />}
      {showCosmo && <CosmoHighlight />}
    </>
  );
}

function CosmoHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("handleMousEnter");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 731.148)">
        <g id="cosmo-marker" transform="translate(3775.926 1809.797)">
          <g
            id="Group_3122-2"
            data-name="Group 3122"
            transform="translate(0 0)"
          >
            <g
              transform="matrix(1, 0, 0, 1, -3826.86, -2517.67)"
              filter="url(#Union_2-7)"
            >
              <path
                id="Union_2-15"
                data-name="Union 2"
                d="M30,126.734a30,30,0,0,1-30-30v-7.2L-30.975,63.026,0,38.336V30A30,30,0,0,1,30,0H509.586a30,30,0,0,1,30,30V96.734a30,30,0,0,1-30,30Z"
                transform="translate(3826.86 2517.67)"
                opacity="0.9"
              />
            </g>
          </g>
          <image
            id="MicrosoftTeams-image_26_"
            data-name="MicrosoftTeams-image (26)"
            height="170"
            transform="translate(32.986 -10)"
            xlinkHref={COSMO_INFORMATION_LOGO}
          />
        </g>
      </g>

      <path
        className="area_selected_stroke"
        id="cosmopolitan_level_2"
        fill="rgba(255,255,255,0)"
        d="M-3337.21-11446.247h435.821l2.878,566-159.846,6.469-.321,464.322h159.409l4.468,323.272-55.624,104.928h-384.724v47.051h-58.339v-72.456l-75.39-3.359v-55.773l10.24-44.024,123.489-1.547v-266.015l-2.383-6.965Z"
        transform="translate(6819.667 13216.041)"
        onMouseOver={handleMousEnter}
      />
    </>
  );
}

function NomadHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 738.148)">
        <g id="nomad-marker" transform="translate(399.306 1341.887)">
          <g
            transform="matrix(1, 0, 0, 1, -488.27, -2073.03)"
            filter="url(#Union_2-4)"
          >
            <path
              id="Union_2-12"
              data-name="Union 2"
              d="M30,137.828a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H283.892a30,30,0,0,1,30,30V47.888l25.455,21.026L313.893,89.94v17.888a30,30,0,0,1-30,30Z"
              transform="translate(488.27 2073.03)"
              opacity="0.9"
            />
          </g>
          <image
            id="MicrosoftTeams-image_24_"
            data-name="MicrosoftTeams-image (24)"
            width="250.778"
            height="45.951"
            transform="translate(35.448 43.861)"
            xlinkHref={NOMAD_INFORMATION_LOGO}
          />
        </g>
      </g>

      <g
        fill="rgba(255,255,255,0)"
        className="area_selected_stroke"
        id="no_mad"
        transform="translate(743.321 2036.599)"
        onMouseOver={handleMousEnter}
      >
        <path
          id="nomad-outline"
          d="M-7595.54-10997.146l64.345,27.158-50.558,108.065,20.745,10.271,14.936-29.992,64.086,27.334,9.727-20.772,3-1.14,26.775-9.764,32.223,17.564.03,43.577-23.916,17.673-97.048-41.887-19.857,40.867-4.811,3.766-7.988,7.237-4.953,6.059-4.67,6.634-11.132,6.618-71.806,165.165-19.349,13.91-163.609-68.941,77.51-182.979,2.055.784,20.484-46.878v-1.5l57.047,23.2,13.853-25.457,23.434,10.618Z"
          transform="translate(7839.37 10997.146)"
        />
      </g>
    </>
  );
}

function ParkMgmHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 731.148)">
        <g id="park-mgm-marker" transform="translate(1315.475 1745.935)">
          <g
            transform="matrix(1, 0, 0, 1, -1404.44, -2477.08)"
            filter="url(#Union_2-2)"
          >
            <path
              id="Union_2-10"
              data-name="Union 2"
              d="M72.66,187.939a30,30,0,0,1-30-30V129.787L0,93.864,42.659,57.941V30a30,30,0,0,1,30-30H595.831a30,30,0,0,1,30,30v127.94a30,30,0,0,1-30,30Z"
              transform="translate(1404.44 2477.08)"
              opacity="0.9"
            />
          </g>
          <rect
            id="MicrosoftTeams-image_22_"
            data-name="MicrosoftTeams-image (22)"
            width="504"
            height="129"
            transform="translate(80.557 30.918)"
            fill="url(#pattern)"
          />
        </g>
      </g>

      <g
        className="area_selected_stroke"
        id="park_mgm"
        transform="translate(587.558 1743.795)"
        onMouseOver={handleMousEnter}
      >
        <path
          id="parkmgm-outline"
          d="M-7290.674-10864.98l-8.858,54.987,3.287,568.476h-8.72v44.19l-46.288,1.607-29.461,40.922-20.728-11.347-24.5-1.891-13.7,7.47.538,86.979-2.426,4.774-3.878,3.44-3.969,2.627-3.422,1.379h-148.936l-32.986-.547-21.091-2.289-9.058-2.407-1.1,4.7-4.2-.663,1.382-6.356-19.614-4.344-4.237,5-3.251-.66-14.937,13.756-17.189,8.155-19.846,2.2v11.3h-102.362l43.527-105.334-26.778-26.035-15.263-16.241-15.557-19.1-14.015-20.422-9.7-15.849-9.232-20.465,22.208-7.872-7.872-32.129h-19.379v-67.33h-5.2v-3.285l-28.963-14.365-33.06-23.681-21.524-16.789-27.449-27.3-23.3-30.865-25.272-44.952-17.6-41.941-10.577-46.182-4.155-46.116,1.55-43.407,9.948-52.389,14.716-42.012,11.782,4.095,13.22-27.656,4.854-8.308,4.823-2.97,28.388-41.144,35.322-36.85,43.964-31.271,9.4,14.979-23.9,59.65,164.131,67.972c2.725,1.129,2.01.782,2.01.782l18.607-14.111,71.039-164.016,11.1-6.688,5.1-7.167,4.847-5.781,7.908-7.1,4.524-3.257,18.86-42.654,96.949,42.019,23.977-17.685v-43.562l-32.274-17.532-26.814,9.681-30.5-20.036,32.935-45.069-20.736-15.8v-100.066H-7709.4v-93.165h118.206v-108.45h19.554v-18.5h35.875v-12.571H-7433v52.488l63.8,63.981-39.794,43.728v17.109l7.162-5.785h47.472v-22.1h12.448v-56.222l39.1-20.722,7.67,13.271h69.109l-24.5-44.632,36.471-22.437,41.642,75.268,5.911,9.074,11.016,10.517,16.9,6.719,287.633.965,20.851,1.608,12.933,3.253,7.5,3.858,7.953,6.485,6.956,7.3,5.354,6.9,5.459,9.008,3.773,7.972,1.79,5.087,1.073,5.165.922,5.47.837,5.824v73.43l-.6,3.258-1.34,2.935-1.665,2.685-2.971,1.908-3.316.948-3.3.714h-133.053l-40.113,59.166-24.3-16.06-5.885,8.747-14.3-8.747-22.952,37.619-212.577-126.15,7.973,57.083,233.827,139.668-27.2,45.1,82.855-.54-98.439,171-62.143-36.044-15.8,26.476-36.908-22.125-29.189,51.246-37.638-22.991-4.378,7.051-35.292-20.687Z"
          transform="translate(8099.392 11489.814)"
          fill="rgba(255,255,255,0)"
        />
      </g>
    </>
  );
}

function BellagioHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 731.148)">
        <g id="bellagio-marker" transform="translate(4272.629 8.68)">
          <g
            transform="matrix(1, 0, 0, 1, -4361.6, -739.83)"
            filter="url(#Union_2-3)"
          >
            <path
              id="Union_2-11"
              data-name="Union 2"
              d="M46.262,187.939H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H398.018a30,30,0,0,1,30,30v127.94a30,30,0,0,1-30,30H106.989L76.626,224Z"
              transform="translate(4361.6 739.83)"
              opacity="0.9"
            />
          </g>
          <image
            id="MicrosoftTeams-image_23_"
            data-name="MicrosoftTeams-image (23)"
            width="318.064"
            height="126.32"
            transform="translate(54.9 26.77)"
            xlinkHref={BELLAGIO_INFORMATION_LOGO}
          />
        </g>
      </g>

      <g
        className="area_selected_stroke"
        id="Bellagio"
        transform="translate(3910.294 976.918)"
        onMouseOver={handleMousEnter}
      >
        <path
          id="bellagio-Outline"
          d="M-2385.26-13310.927l-19.317-1.158.344-242.523,15.653-16.52,262.057.667v5.667l22.075-.785h1.673l6.18-4.882h61.62v49.755l-6.574,4.46h-4.353l.62,118.078h-3.631l.153,84.222h29.682l.085-305.955,7.462-5.019,821.574.169.069,170.412,101.3-.066-.062,93.342-95.5.364.033,78.065h8.019v43.352h-13.338v36.331h35.69v11.978l81.063.139v32.725l-9.834,3.072H-1112.2l.159,180.483h9.516v38.945h-51.22v8.328h63.9v68.5h61.24v64.724h-37.2v127.286h44.647v67.481h-3.414v36.966h16.12l1-69.059,9.853-9.3-.619-118.351h121.309l1.309-257.359,289-.239v301.282H-701.663v10.135l-17.3,27.066v35.994l-12.255,56.782-32.6-13.5-18.194,50.822,8.806.5,81.783,38.5-18.566,45.226h35.8v8.908h28.884v30.826h53.79l7.595,8.007v17.9l86.184.975,10.2,1.688v114.051h-77.109l-11.4-2.271h-7.87v17.415l-8.627,8.627h-109.7v31.746h70.985l13.949,21.915-17.674,44.139,4.764,10.333v21.526l89.127,39.809,1,75.4-63.415,35.168-11.674-3.114-2.285,1.113,2.706,5.408,8.628,11.327,14.927,15.761,11.3,8.673,28.568,16.118,21.658,6.925,18.535,4.08v62.221h7.1l11.209,3.4v24.436h15.666l11.081,3.617v90.121l.871,121.262h14.564l11.662,4.656v60.994h74.929v31.288l-82.623-.723,7.694,3.705v89.763h-39.048v152.815H-509.86v-107.425l-9.746.722-5.875,1.623-9.459,1.9-6.368,1.655-7.389,2.835-12.309-6.392-15.679-57.571,7.019-3.123-21.3-71-8.208-8.106-3.351-4.379-4.674-13.717,1.909-15.469-24.753,12.052h-56.067v-8.8H-697.26v-11.146h-4.079l-1.962-2.652-2.349-3.366-.929-5.22.929-5.5,1.817-3.562,2.494-1.408h5.5v-10.783h12.181v-31.409h-7.562l-10.118-23.623,4.079-5.355,4.477-6.795,1.562-9.445-1.562-8.771-5.3-6.953-3.252-1.932-5.24-1.28-12.791,2.26-15.362-31.029,11.045-5.4.341-32.691v1.455h-15.512l-32.064-62.049,2.034-24.268-68.32-85.511-14.695-17.062,1.605-1-6.568-6.432-10.914-1.825-9.92-6.84-4.76-8.611v-7.781l-8.124-8.1,6.572-6.409-5.119-5.312-127.225.331v22.056l-14,7.629-12.908-7.725v-8.214h-4.968v-15.749l3.529-7.758-43.891-30.548-9.1,8.557-14,4.285-12.047,12.7-9.183,6.349-6.173,2h-9.44l-8.374-3.343-7.133-5.01-5.323-6.8,2.31-5.892-10.447-7.166-76.943,17h-8.244v53.444l-79.409,1.043-7.283-3.973.157-71.683h14.42v-36.446h-14.576v-83.056l-131.7-104.607-9.084,10.112h-11.429l-8.306,8.723-26.123-17.343h-32.452v192.2l-28.054,29.36h-41.363l-31.848-22.111v-104.1l-8.482-3v-18.633l-136.517,125.729h-18.228l-5.873-3.217v-59.77h-384.271l-4.962-4.345.048-755.788,4.646-1.19h301.416v27.389h70.423l30.92,28.3v-16.215l-37.449-36.115h-29.406l.828-36.046h38.58v-3.478h-193.591v-5.443h-27.625v-11.78h-129.9v-57.424H-2238v44.1h-86.284v-116.7h-63.3l.448-182.223h-1.584v-40.063h3.408Z"
          transform="translate(2422.302 13624.92)"
          fill="rgba(255,255,255,0)"
        />
      </g>
    </>
  );
}
function VdaraHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 731.148)">
        <g
          id="aria-marker-2"
          data-name="aria-marker"
          transform="translate(3102.415 150.839)"
        >
          <g
            transform="matrix(1, 0, 0, 1, -3191.38, -881.99)"
            filter="url(#Union_2-7)"
          >
            <path
              id="Union_2-15"
              data-name="Union 2"
              d="M189.482,179.585H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H278.072a30,30,0,0,1,30,30V149.585a30,30,0,0,1-30,30H250.207l-30.363,36.057Z"
              transform="translate(3191.38 881.99)"
              opacity="0.9"
            />
          </g>
          <image
            id="MicrosoftTeams-image_27_"
            data-name="MicrosoftTeams-image (27)"
            width="165"
            height="104"
            transform="translate(70.616 40.014)"
            xlinkHref={VDARA_INFORMATION_LOGO}
          />
        </g>
      </g>

      <g
        transform="translate(3295.082 1100.811)"
        fill="rgba(255,255,255,0.01)"
        id="vdara"
        className="area_selected_stroke"
        onMouseOver={handleMousEnter}
      >
        <path
          id="vdara-outline"
          d="M-3500.428-12562.709l78.741-.155v4.213h35.622l11.215-6.413,5.692,9.806,24.348-12.044,6.138,8.651,9.061-5.333h38.635l42.99,102.331v20.441l-65.25,19.369,6.726,27.315-52.482,13.779-8.073-29.847,8.073-1.926-3.421-17.1,24.519-6.928-5.35-19.2-6.9-18.235-4.288-7.959-22.275,10.023,2.18,27.108-12.776,3.355-.66,30.222-10.032,3.2-9.667,3.967-8.6,4.331-10.252,5.93v-2.54l-5.222,1.048,1.173,4.506,24.6-5.554,13.634,70h3.839l-1.988-20.542,50.407-7.047,2.234,20.232h-7.522v4.428h-6.363v6.754l37.915-3.308,1.823,20.817.786,25.542v10.422l-.786,21.8-1.9,21.539-47.676-3.782v-3.28h-6.568l-19.253,111.767-53-15.967-3.636,23.776,80.27,32.678-20.237,40.78-29.6-12.673-6.946,11.884,31.5,17.4-17.462,29.714-30.954-17.028-58.679,102.414h-66.1l32.062-49.951,14.076-24.694,10.811-21.444-6.413-4.726,9.9-11.479,11.5-14.658,10.309-14.933,8.31-13.521-19.073-12.435-1.57-51.164-6.4-34.795-8.479-28.783-8.043-22.979-2.876-6.822,8.405-3.021-3.174-8.808-5.231-15.945-2.988-19.245v-18.987l2.3-14.937,2.97-14.26,3.619-13.712-7.409-2.547,12.96-29.46,6.368-19.522,3.521-12.947,5.281-21.025,4.689.73,9.837,1.223,9.463.594,8.519-.594,3.3-.6v-21.443h33.2v-9.284h-77.8Z"
          transform="translate(3562.227 12567.303)"
        />
      </g>
    </>
  );
}

function TMobileHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g transform="translate(88.969 731.148)" onMouseOver={handleMousEnter}>
        <g id="tmobile-marker" transform="translate(0 0)">
          <g id="Group_3122" data-name="Group 3122" transform="translate(0)">
            <g
              transform="matrix(1, 0, 0, 1, -88.97, -731.15)"
              filter="url(#Union_2-5)"
            >
              <path
                id="Union_2-13"
                data-name="Union 2"
                d="M35.606,157.811H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H509.788a30,30,0,0,1,30,30v97.812a30,30,0,0,1-30,30H86.015l-25.2,30.514Z"
                transform="translate(88.97 731.15)"
                opacity="0.9"
              />
            </g>
          </g>
          <image
            id="MicrosoftTeams-image_25_"
            data-name="MicrosoftTeams-image (25)"
            width="462.487"
            height="51.917"
            transform="translate(44.105 53.089)"
            xlinkHref={TMOBILE_INFORMATION_LOGO}
          />
        </g>
      </g>
    </>
  );
}

function AriaHighlight() {
  const handleMousEnter = () => {
    let timercheck = setTimeout(() => {
      console.log("movinf");
      __showDollHouseModal(false, 0, 0, "");
      clearTimeout(timercheck);
    }, 0);
  };

  return (
    <>
      <g id="Markers" transform="translate(88.969 731.148)">
        <g id="aria-marker" transform="translate(2060.779 473.678)">
          <g
            transform="matrix(1, 0, 0, 1, -2149.75, -1204.83)"
            filter="url(#Union_2)"
          >
            <path
              id="Union_2-9"
              data-name="Union 2"
              d="M248.559,187.939H30a30,30,0,0,1-30-30V30A30,30,0,0,1,30,0H337.15a30,30,0,0,1,30,30v127.94a30,30,0,0,1-30,30H309.285L278.922,224Z"
              transform="translate(2149.75 1204.83)"
              opacity="0.9"
            />
          </g>
          <use
            id="MicrosoftTeams-image_29_"
            data-name="MicrosoftTeams-image (29)"
            transform="translate(102.487 34.991)"
            xlinkHref="#image"
          />
        </g>
      </g>

      <g
        fill="rgba(255,255,255,0)"
        className="area_selected_stroke"
        id="area"
        transform="translate(1924.587 1442.952)"
        onMouseOver={handleMousEnter}
      >
        <path
          id="aria-outline"
          d="M-5264.744-11993.956v3.133l96.5.069,7.381-1.647,7.317-.821h7.571l4.22.349,6.26.884,7.383,1.694,10.039,3.709,67.96,26.88-2.526,11.134-2.627,12.076-3.145,19.609-.995,8.877-1.119,15.5-.407,6.467v19.73l-6.848,4.545,2.511,26.93,8.426,30.762,9.117,23.038,8.7,17.63,14.317,19.5,4.819,6.836,13.952,17.241,24.689,24.221,15.175,13.139,20.671,15.393,27.344,15.258,32.607,14.947-8.6,36.132,183.9,21.7,14.6,109.405,79.838,66.132,15.17,65.45,11.564-2.156,24.483,112.81-43.4,4.523-1.63,43.309-96.929,17.8,1.515,6.023.017,101.088-131.982.917v-4.524l-54.389-4.039-1.652,4.039h-4.046l10.5-42.145-239.807.959v-3.775h-3.345v-7.747l-2.567-67.758-11.872-55.915-12.165-31.217-13.062-19.713-10.409,6.833-11.868-16.05-6.762,5.558-19.219-20.507-14.891-18.847-4.259,2.272,1.1.876-1.1,1.644-3.646.817h-4.566l-8.41-.817-11.008-2.52-7.693-3.587-7.512-4.466-6.678-4.877.458-.771-10.093-9.479-5.5,6.61-12.936-5.032-8.461-2.824-10.825-2.609-9.818-1.064h-5.231l1.511-1.376-4.822-4.144-3.254-2.428h-2.632l-6.009,4.1-5.731,2.473-9.526,3.493-6.2,1.557h-10.273l-10.431-.7v-.876l-2.936-.565-2.918-.5-3.293-.427-2.314-.277-.428,8.223-5.247.208-6.018.33-6.76,1.264-6.611,2.188-8.857,3.127-9.767,4.732-3.664,1.967-4.206,2.784-5.038,1.415-7.62,6.522-7.645,5.534-10.444,5.363-15.6,6.191-8.268,1.665-4.465-.434-.931-1.911v-2.512l.3-2.561-5.571-3.766-9.443,10.749-6.238,7.8-5.765,7.937-5.662,7.79-7.086,10.726-6.542,11.688-4.137,8.257-5.064,10.93-7.442,13.356-3.812,13.881-3.186,12.8h-1.981l-60.292-5.579-2.325-.258-22.692,55.682-104.7-71.942,34.9-75.984-58.624,20.237-.732-62.9h8.529l.736-18.932h-9.266V-11493.5h9.592v-25.007h-9.592v-128.074h-43.724v-204.041h112.474v-27.163h-23.441v-21.338h-60.666v-93.211Z"
          transform="translate(5858.85 11993.956)"
        />
      </g>
    </>
  );
}
